<template>
  <div class="login-1">
    <authentication-forms-container :image="image" :image-parent-class="imageParentClass">
      <ClassicLogin @login="loginController" :redirect="redirect"
                    v-if="findAttributeOnSiteInfo('login_options')[0]==0">


        <template #classic-login-p-1-top>
          <slot name="classic-login-p-1-top"></slot>
        </template>

        <template #class-login-p-1-bottom>
          <slot name="classic-login-p-1-bottom"></slot>
        </template>

      </ClassicLogin>
      <two-step-login @login="loginController" :redirect="redirect"
                      :showPanels="showPanels"
                      :default-panel="defaultPanel"
                      v-if="findAttributeOnSiteInfo('login_options')[0]==1">

        <template #two-step-login-p-1-top>
          <slot name="two-step-login-p-1-top"></slot>
        </template>

        <template #two-step-login-p-1-bottom>
          <slot name="two-step-login-p-1-bottom"></slot>
        </template>


      </two-step-login>
    </authentication-forms-container>
  </div>
</template>

<script>
import AuthenticationFormsContainer from "../Form/AuthFormsContainer";
import ClassicLogin from "./ClassicLogin";
import TwoStepLogin from "./TwoStepLogin";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {loginProps} from "./LoginProps";

export default {
  name: "Login1",
  components: {AuthenticationFormsContainer, ClassicLogin, TwoStepLogin},
  props: {
    ...loginProps
  },
  methods: {
    showToastAfterRedirectFromDashboard() {
      if (this.$route.name === 'Login') {
        toast(this.$t('authentication_general.authentication_message_if_user_not_login'), this.$t('authentication_general.authentication_message_if_user_not_login'), 'danger')
      }
    },
    loginController(data) {
      this.$emit('login', data)
    }
  },
  mounted() {
    this.showToastAfterRedirectFromDashboard()
  }

};
</script>
<style scoped>


</style>